import ActionButton from './ActionButton';
import ClaimPrizeModal from './ClaimPrizeModal';
import useTournamentActionButton from './hooks/useTournamentActionButton';
import { TournamentFragment } from '@/shared/graphql/TournamentFragment.generated';

type Props = {
  tournament?: TournamentFragment;
  page?: 'list' | 'details' | 'game';
  translations: Record<string, string>;
  isLoggedIn: boolean;
  walletCurrency: string;
  updateTournament: () => Promise<void>;
};

const TournamentActionButton: FC<Props> = ({
  tournament,
  page,
  translations,
  isLoggedIn,
  walletCurrency,
  updateTournament,
}) => {
  const {
    handleAction,
    loading,
    defaultTranslation,
    pastTranslation,
    toggleDialog,
    showDialog,
    canClaimPrize,
    isAutomaticallyReleased,
    isDisabled,
    status,
  } = useTournamentActionButton({
    tournament,
    page,
    name: tournament?.name,
    translations,
    isLoggedIn,
    walletCurrency,
    updateTournament,
  });

  return (
    <>
      <ActionButton
        canClaimPrize={canClaimPrize}
        isAutomaticallyReleased={isAutomaticallyReleased}
        defaultTranslation={defaultTranslation}
        pastTranslation={pastTranslation}
        handleAction={handleAction}
        iAmOptedIn={tournament?.iAmOptedIn}
        loading={loading}
        status={status as TournamentStatus}
        toggleDialog={toggleDialog}
        isDisabled={isDisabled}
      />
      <ClaimPrizeModal
        toggleDialog={toggleDialog}
        tournament={tournament}
        showDialog={showDialog}
        loading={loading}
        handleAction={handleAction}
        translations={translations}
      />
    </>
  );
};

export default TournamentActionButton;
